import { icons } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { URLs } from "../../resources/url";
/**
 * Entidades que soportan properties. Agregar una fila alcanza para habilitar
 * una entidad nueva; el orden es el orden de los chips.
 *
 * Backend acepta más entidades (Project y Client entre ellas): `entityName` es
 * texto libre, no hay enum. Acá se listan solo las que se quieren exponer.
 */
export var PROPERTY_ENTITIES = [
    {
        /* `label` es solo presentación: la entidad sigue siendo ProjectType y es
           "ProjectType" lo que viaja al API. No unificar con el label. */
        entityName: "ProjectType",
        label: "Producto",
        icon: icons.Label,
        url: URLs.projectType,
        sendClientId: true,
    },
    {
        entityName: "Plan",
        label: "Plan",
        icon: icons.MenuBook,
        url: URLs.plans,
    },
    {
        entityName: "CoverType",
        label: "Tipo de cobertura",
        icon: icons.Shield,
        url: URLs.coverType,
    },
];
